export interface WorkflowRoleModel {
  key: string;
  abbreviation: string;
  name: string;
  requiredForRegion: string[];
}

export function workflowRoleModelFactory(json?: any): WorkflowRoleModel {
  json = json || {};

  return {
    key: json["key"],
    abbreviation: json["abbreviation"],
    name: json["name"],
    requiredForRegion: Array.from(json["requiredForRegion"] || []).map(it => (it ? `${it}` : "")).filter(it => !!it),
  } as WorkflowRoleModel;
}

export function workflowRoleModelListFactory(json?: any): WorkflowRoleModel[] {
  return Array.from(json || []).map(it => workflowRoleModelFactory(it)) as WorkflowRoleModel[];
}
